module.exports = __webpack_public_path__ + "static/media/password.ccd7b0f3.svg";